export default {
  baseUrl: 'http://dev-geekchic.bidiworks.com',
  apiBaseUrl: 'http://dev-geekchic.bidiworks.com/api'
  // // apiBaseUrl: 'http://127.0.0.1:8000'
};
